import { Map, TileLayer, Marker } from "react-leaflet";

import L from "leaflet";

const iconPerson = new L.Icon({
  iconUrl: "/pin.png",
  iconRetinaUrl: "/pin.png",
  iconSize: new L.Point(37, 37),
  className: "map-position",
});

interface StaticMapProps {
  zoom: number;
  center: any;
  position: any;
  style: any;
  draggable?: boolean;
}

const StaticMap = (props: StaticMapProps) => {
  const { center, zoom, position, style } = props;

  return (
    <Map style={style} center={center} zoom={14}>
      <TileLayer url="https://{s}.tile.osm.org/{z}/{x}/{y}.png" />
      <Marker icon={iconPerson} position={position} readOnly={false}></Marker>
    </Map>
  );
};

export default StaticMap;
